import { Route, Switch } from 'react-router';

import AlchemyPage from 'common/alchemyComponents/AlchemyPage';
import NotFound from 'common/components/ErrorPages/NotFound';

import { SettingsRewards } from './containers/SettingsRewards';
import { SettingsDashboard } from './containers/SettingsDashboard';

export const settingsBasePath = '/admin/company';

export default function Settings() {
  return (
    <AlchemyPage className="margin-top-large">
      <Switch>
        <Route exact path={settingsBasePath}>
          <SettingsDashboard />
        </Route>

        <Route exact path={`${settingsBasePath}/positive_feedback_components`}>
          <SettingsRewards />
        </Route>

        <Route component={NotFound} />
      </Switch>
    </AlchemyPage>
  );
}
